import createCrud from '../crud';
import modules from './projects/index'

export default createCrud({
    resource: 'projects', modules
  });